import { observable } from 'mobx';
import { createContext } from 'react';

const AssetStore = observable({
  assetsList: [],
  passivesList: [],
  totalAssets: 0,
  totalPassive: 0,
  patrimony: 0
});

AssetStore.sumListValue = function(list) {
  return this[list].length > 0
    ? Object.values(this[list])
        .map(item => item.amount)
        .reduce((prev, next) => prev + next)
    : 0;
};

AssetStore.updateTotals = function() {
  this.totalAssets = this.sumListValue('assetsList').toFixed(2);
  this.totalPassive = this.sumListValue('passivesList').toFixed(2);
  this.patrimony = (this.totalAssets - this.totalPassive).toFixed(2);
};

AssetStore.setValue = function(name, value) {
  this[name] = value;

  this.patrimony = this.assets - this.passive;
};

AssetStore.addAssetPassive = function(name, property) {
  this[property].push({ name: name, description: '', amount: 1000 });
  this.updateTotals();
};

AssetStore.removeAssetPassive = function(name, property) {
  this[property] = this[property].filter(function(value, index, arr) {
    return value.name !== name;
  });
  this.updateTotals();
};

AssetStore.setDetailAsset = function(list, name, property, value) {
  this[list].find(x => x.name === name)[property] = value;
  this.updateTotals();
};

const AssetStoreContext = createContext(AssetStore);

export default AssetStoreContext;
